<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs :pt-5="$vuetify.breakpoint.lgAndUp">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap justify-center align-center pt-5 pb-10>
            <v-flex xs11 lg11>
              <v-card>
                <v-card-title class="bg-card"
                  >{{ $t("dashboard.cor") }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout row wrap ml-3 pa-1>
                    <v-flex xs11 lg11
                      ><b class="mr-2">{{ $t("dashboard.policy") }} :</b>
                      <span v-if="DataMessage.ShowPolicy === true">{{
                        PolicyHeader
                      }}</span>
                      <a v-else v-on:click="Fn_DetailPolicy"
                        >{{ PolicyHeader }}
                      </a>
                      <br />
                      <b>{{ $t("dashboard.org") }} :</b> {{ BusinessNameTh }}
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs11 lg11 pt-5 v-if="DataMessage.ShowPolicy === true">
              <v-card>
                <v-card-title> รายละเอียดนโยบาย </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout row wrap justify-center align-center pa-1>
                    <v-flex xs12 lg12 text-left>
                      <div v-html="PolicyDetail"></div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              xs11
              lg11
              pt-5
              v-else
              v-for="(item, index) in Consent"
              :key="index"
            >
              <v-card>
                <v-card-title>
                  {{ index + 1 }}. {{ item.Header }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout row wrap justify-center align-center pa-1>
                    <v-flex xs12 lg12 text-left>
                      <div class="pb-2">
                        <b
                          v-if="
                            item.Status === 'approve' ||
                            item.Status === 'unapprove'
                          "
                        >
                          {{ $t("dashboard.status") }}
                          <v-chip
                            color="green"
                            small
                            v-if="item.Status === 'approve'"
                            dark
                          >
                            ยินยอม</v-chip
                          >
                          <v-chip
                            color="red"
                            small
                            dark
                            v-else-if="item.Status === 'unapprove'"
                          >
                            ไม่ยินยอม</v-chip
                          >
                        </b>
                      </div>
                      <div class="pb-1">
                        <b>รายละเอียดยินยอม</b>
                      </div>
                      <span v-html="item.Detail"></span>
                      <div class="pb-1">
                        <b>รายละเอียดไม่ยินยอม</b>
                      </div>
                      <span v-html="item.Reject"></span>
                      <div class="pb-1">
                        <b>ข้อมูลที่ต้องการขอ</b>
                      </div>
                      <v-chip
                        small
                        style="border: 1px solid"
                        v-for="(tag, i) in item.Tag.split(',')"
                        :key="i"
                        class="ma-1"
                        label
                        text-color="#077893"
                        color="#ddf7ff"
                      >
                        {{ tag }}
                      </v-chip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-text>
                  <v-layout row wrap ml-3 pa-1>
                    <v-flex xs11 lg11>
                      <span v-html="item.ConsentDetail"></span>
                      <div>
                      </div>
                    </v-flex>
                    <v-flex xs10 lg3 v-if="ShowStatus">
                      <v-radio-group
                        v-model="item.Status"
                        row
                        :rules="[(v) => !!v || 'กรุณาเลือก ความยินยอม']"
                      >
                        <v-radio label="ยินยอม" value="approve"></v-radio>
                        <v-divider vertical></v-divider>
                        <v-radio
                          class="ml-5"
                          label="ไม่ยินยอม"
                          value="unapprove"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs10 lg3 v-else-if="!ShowStatus"> </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            justify-center
            align-center
            pt-4
            pb-7
            v-if="NameBtnSave === 'ยืนยันตัวเลือกของฉัน'"
          >
            <v-flex xs8 sm8 md3 lg2>
              <v-btn color="#077893" dark block @click="Fn_Save()">
                {{ NameBtnSave }}
              </v-btn>
            </v-flex>
            <v-flex
              xs8
              sm8
              md3
              lg2
              :ml-4="$vuetify.breakpoint.lgAndUp"
              :pt-3="$vuetify.breakpoint.smAndDown"
            >
              <v-btn color="#077893" outlined block @click="Fn_Cancle"
                >ยกเลิก</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-center align-self-center pb-4 v-else>
            <v-flex xs11 sm11 md3 lg3>
              <v-alert outlined type="success" text>
                {{ NameBtnSave }}
              </v-alert>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogGeneralConsent
        :show="DialogGeneral"
        :_header="PolicyHeader"
        :_detail="PolicyDetail"
        @closeDialogDelete="DialogGeneral = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import DialogGeneralConsent from "@/components/dialog/DialogGroupConsentDetail.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogGeneralConsent, OverlaySearch },
  data: function () {
    return {
      valid: true,
      ShowStatus: true,
      Consent: [],
      DataMessage: [],
      DataConsentStatus: [],
      Detail: "",
      PolicyHeader: "นโยบายวันนี้",
      PolicyDetail: "",
      BusinessNameTh: "",
      AccessToken: "",
      BusinessId: "",
      GroupId: "",
      Status: "",
      itemsRequest: [],
      loadingDownloadData: false,
      DialogGeneral: false,
      NameBtnSave: "ยืนยันตัวเลือกของฉัน",
    };
  },
  computed: {
    ...mapGetters(["DataGroupConsent"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },

    _SendId: {
      get() {
        return this.DataGroupConsent.SendId || "-";
      },
    },
  },
  mounted() {
    this.Fn_GetToken();
  },
  methods: {
    async Fn_GetToken() {
      this.loadingDownloadData = true;
      var payload = {
        ShareToken: this.$route.path.split("/")[3],
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "token/login",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.AccessToken = response.data.Message.OneAccessToken;
            this.$cookies.set(
              "AccountId",
              response.data.Message.OneAccountId
            );
            this.Fn_getDataConsent();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_getDataConsent() {
      this.loadingDownloadData = true;
      var payload = {
        Id: this.$route.path.split("/")[2],
        AccessToken: this.AccessToken,
      };
      var Headers = {
        AccountId: this.$cookies.get("AccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/GetConsentDetails",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.DataMessage = response.data.Message;
            this.Consent = response.data.Message.Consent;
            this.PolicyHeader = response.data.Message.Policy.Header;
            this.PolicyDetail = response.data.Message.Policy.Detail;
            this.BusinessNameTh = response.data.Message.BusinessNameTh;
            this.Status = response.data.Message.Consent[0].Status;
            
            for (var item of response.data.Message.Consent) {
              var FixArray = item.Tag;
              this.itemsRequest = FixArray.split(",").map((item) => item.trim());
              this.Status = item.Status;
              if (this.Status === "approve" || this.Status === "unapprove") {
                this.NameBtnSave = "คุณได้บันทึกรายการเรียบร้อยแล้ว";
                this.ShowStatus = false;
              } else {
                this.NameBtnSave = "ยืนยันตัวเลือกของฉัน";
                this.ShowStatus = true;
              }
            }
          } else {
            window.close();
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          window.close();
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_DetailPolicy() {
      this.DialogGeneral = true;
    },
    async Fn_Save() {
      if (this.$refs.form.validate()) {
        this.DataConsentStatus = [];
        for (var i = 0; i < this.Consent.length; i++) {
          var x = {
            ConsentId: this.Consent[i].Id,
            Status: this.Consent[i].Status,
          };
          this.DataConsentStatus.push(x);
        }
        var payload = {
          BusinessId: this.DataMessage.BusinessId,
          Id: this.$route.path.split("/")[2],
          Consent: this.DataConsentStatus,
          PolicyId: this.DataMessage.Policy.Id,
          AccountId: this.DataMessage.AccountId,
          BusinessId: this.DataMessage.BusinessId,
          GroupId: this.DataMessage.GroupId,
        };
        var Headers = {
          AccountId: this.$cookies.get("AccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/ConfirmConsent",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loadingDownloadData = false;
            if (response.data.Status === "OK") {
              Toast.fire({
                icon: "success",
                title: this.$i18n.t("alert.confirm"),
              });
              this.NameBtnSave = this.$i18n.t("alert.list");
              this.ShowStatus = false;
              this.Fn_getDataConsent();
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.loadingDownloadData = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    Fn_Cancle() {
      window.close();
      this.$refs.formData.reset();
    },
  },
  watch: {},
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.bg-card {
  background-color: #eeeeee;
}
</style>
